import { ASSETS } from 'core/assets';
import React from 'react';
import { getDomainTheme } from 'src/styles/themeLoader';

interface ImageProps {
  src: string;
  alt?: string;
  width?: number | string;
  height?: number | string;
  className?: string;
  priority?: boolean;
  onClick?: () => void;
  onError?: (e: React.SyntheticEvent<HTMLImageElement>) => void;
  isSrcDynamic?: boolean;
  fallbackImage?: string;
}

const OnbImage: React.FC<ImageProps> = ({
  src,
  alt = '',
  width,
  height,
  className,
  priority = false,
  onClick,
  isSrcDynamic = false,
  fallbackImage,
}) => {
  const domainTheme = getDomainTheme().toUpperCase();;
  const fallbackSrc = fallbackImage ? ASSETS[fallbackImage][domainTheme] : '';
  const resolvedSrc = isSrcDynamic ? src : ASSETS[src][domainTheme];

  return (
    <img
      src={resolvedSrc}
      alt={alt}
      width={width}
      height={height}
      className={className}
      loading={priority ? 'eager' : 'lazy'}
      decoding="async"
      onClick={onClick}
      onError={(e) => {
        (e.target as HTMLImageElement).src = fallbackSrc;
      }}
    />
  );
};

export default OnbImage;
